<template>
  <v-dialog v-model="internalValue" :max-width="maxWidth" persistent tile scrollable>
    <v-card class="standard-dialog" rounded="0">
      <v-card-title class="dialog-header">
        <div>
          <v-row align="center" no-gutters>
            <v-icon left size="24" color="white">{{ icon }}</v-icon>
            <div class="ml-2">
              <div class="dialog-header-content">
                <span class="dialog-title">{{ title }}</span>
              </div>
              <div v-if="subtitle" class="toolbar-subtitle">
                <span class="text-body-2">{{ subtitle }}</span>
              </div>
            </div>
          </v-row>
        </div>
        <div class="dialog-header-actions">
          <slot name="header-actions"></slot>
          <v-btn icon @click="close" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="dialog-body pa-4">
        <slot></slot>
      </v-card-text>
      <template v-if="!hideActions">
        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <slot name="actions">
            <v-btn
              :color="primaryColor"
              :disabled="disabled"
              :loading="loading"
              depressed
              @click="$emit('save')"
            >
              <v-icon left small v-if="saveIcon">{{ saveIcon }}</v-icon>
              {{ saveText }}
            </v-btn>
          </slot>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StandardDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "mdi-pencil",
    },
    maxWidth: {
      type: [String, Number],
      default: "600",
    },
    saveText: {
      type: String,
      default: "Sačuvaj",
    },
    cancelText: {
      type: String,
      default: "Odustani",
    },
    saveIcon: {
      type: String,
      default: "mdi-content-save",
    },
    primaryColor: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.standard-dialog {
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 64px);
}

.dialog-header {
  background: linear-gradient(135deg, #ef6621 0%, #f57c00 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.dialog-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
}

.dialog-body {
  padding: 24px;
  min-height: 100px;
  flex: 1 1 auto;
  overflow-y: auto;
}

.dialog-actions {
  padding: 16px 24px;
  background: #fafafa;
}
</style>
